export default {
  labels: {
    page: 'Side {{current}} af {{total}}',
    no_file_specified: 'Der blev ikke angivet nogen fil',
  },
  buttons: {
    previous: 'Forrige',
    next: 'Næste',
  },
};
